import React, { useState } from 'react';
import { cn } from './cn';

const SIZES = {
  xs: 'w-[18px] h-[18px] text-[10px]',
  sm: 'w-6 h-6 text-[11px]',
  base: 'w-8 h-8 text-xs',
  md: 'w-10 h-10 text-sm',
  lg: 'w-11 h-11 text-sm',
  xl: 'w-14 h-14 text-base',
};

function initialsOf(name = '') {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

/** Avatar — ảnh (fallback initials) tròn/bo. */
export function Avatar({ src, name = '', size = 'md', shape = 'circle', className, ...props }) {
  const [errored, setErrored] = useState(false);
  const showImg = src && !errored;
  return (
    <span
      className={cn(
        'inline-flex items-center justify-center overflow-hidden flex-shrink-0 font-medium select-none',
        'bg-brand-softer text-brand-fg-strong',
        shape === 'circle' ? 'rounded-full' : 'rounded-xl',
        SIZES[size] || SIZES.md,
        className
      )}
      {...props}
    >
      {showImg ? (
        <img
          src={src}
          alt={name || 'avatar'}
          className="w-full h-full object-cover"
          onError={() => setErrored(true)}
        />
      ) : (
        <span aria-hidden="true">{initialsOf(name)}</span>
      )}
    </span>
  );
}

export default Avatar;
